<template>   
   <HeaderDash />
   <SideMenu /> 
   <Content404 /> 
</template>

<script>
// Importando los componententes pertenecientes a esta vista
import HeaderDash from '@/components/manager/dashboard/HeaderDash.vue'
import SideMenu from '@/components/manager/dashboard/SideMenu'
import Content404 from '@/components/manager/dashboard/modules/404/Content404'
export default 
{
  name: '404',
  components: 
  {
    HeaderDash,
    SideMenu,
    Content404
  }
}
</script>

<style>


</style>
